export default "tareas\n"